import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import '@fortawesome/fontawesome-free/css/all.css';
import ClickEffects from './modules/ClickEffects';

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

// Create the app first
const app = createApp(App);
const pinia = createPinia()

// Use plugins and router
app.use(router);
app.use(VueSweetalert2);

// Use pinia store
pinia.use(piniaPluginPersistedstate)
app.use(pinia)

// Custom modules (like your click effect)
ClickEffects();

// Mount the app
app.mount('#app');
